import { render, staticRenderFns } from "./OrganizationDeleteModal.vue?vue&type=template&id=7c172ea3&scoped=true"
import script from "./OrganizationDeleteModal.vue?vue&type=script&lang=js"
export * from "./OrganizationDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./OrganizationDeleteModal.vue?vue&type=style&index=0&id=7c172ea3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c172ea3",
  null
  
)

export default component.exports